<div class="row">
    <div class="col-12">
        <div class="text-center wow pulse" data-wow-iteration="2" data-wow-duration="0.2">
            <h3 class="text-info">Give Your Pet The Best Boarding Experience Book Now!!</h3>
            <p class="text-primary">Use the drop down menus below to select the details of your boarding experience.</p>
        </div>
        <div class="book-appointment-form mx-auto w-100 p-4 mt-5 wow fadeInUp" data-wow-offset="10">
            <div class="row">
                <div class="mb-4 col-md-6">
                    <label class="form-label">Please Select Species:</label>
                    <ng-select class="form-control" dropdownPosition="bottom" [items]="petsList" bindLabel="name"
                        bindValue="id" [searchable]="false" [clearable]="false" [(ngModel)]="selectedPet"
                        [ngModelOptions]="{standalone: true}" [placeholder]="'Select Species'">
                    </ng-select>
                </div>
                <div class="mb-4 col-md-6">
                    <label class="form-label">Number of Pets to Book:</label>
                    <ng-select class="form-control" dropdownPosition="bottom" [items]="numberOfPets"
                        [searchable]="false" [clearable]="false" [(ngModel)]="selectedPetNumber"
                        [placeholder]="'Select Pet Count'">
                    </ng-select>
                </div>
                <div class="mb-4 col-md-6">
                    <label class="form-label">Check-In Date:</label>
                    <p-calendar class="form-input form-input-with-box iconic-feild" [appendTo]="'body'"
                        placeholder="Click here to select check-in date" [(ngModel)]="inwardDate"
                        [minDate]="minInWardDate" [maxDate]="maxDate" [dateFormat]="pCalendarDateFormat"
                        (onSelect)="selectInwardDate()" [readonlyInput]="true" hideOnDateTimeSelect="true"
                        [showIcon]="true" styleClass="p-calendar">
                        <ng-template pTemplate="date" let-date>
                            <span
                                [ngStyle]="{ backgroundColor: getSelectedDays(date)? '#6bb9ff' : 'inherit',color: getSelectedDays(date) ? '#ffffff' : 'inherit'}"
                                class="selected-inward">{{ date.day }}</span>
                        </ng-template>
                    </p-calendar>

                    @if(submitted && !inwardDate){
                    <span class="text-danger error">Please select Check-In date</span>
                    }
                </div>
                <div class="mb-4 col-md-6">
                    <label class="form-label">Check-Out Date:</label>
                    <p-calendar class="form-input form-input-with-box iconic-feild" [appendTo]="'body'"
                        placeholder="Click here to select check-out date" #checkout [(ngModel)]="outwardDate"
                        [disabled]="!inwardDate" [minDate]="inwardDate" [dateFormat]="pCalendarDateFormat"
                        (onSelect)="selectOutwardDate()" [readonlyInput]="true" [showIcon]="true"
                        styleClass="p-calendar">
                        <ng-template pTemplate="date" let-date>
                            <span
                                [ngStyle]="{  backgroundColor: getSelectedDays(date)? '#6bb9ff': 'inherit',color: getSelectedDays(date) ? '#ffffff' : 'inherit' }"
                                class="selected-outward">{{ date.day }}</span>
                        </ng-template>
                    </p-calendar>

                    @if(submitted && !outwardDate){
                    <span class="text-danger error">Please select Check-Out date</span>
                    }
                </div>
                <div class="col-12 text-center">
                    <button class="btn btn-success" type="button" name="button" (click)="checkCageAvailability()">Check
                        Availability</button>

                </div>
            </div>
        </div>
    </div>
</div>